import currency from "currency.js";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { useState, useEffect } from "react";
import { Table, OverlayTrigger, Popover } from "react-bootstrap";
import { useQuery } from "react-query";
// import { services } from "../../config";
import { useAuth } from "../../hooks/useAuth";
import { useDebounce } from "../../utils/hooks";
import { queryActions } from "../../utils/reactQueryActions";
import "./../../assets/scss/scoped/items-table.scoped.scss";
import queryString from "query-string";
import ReactPaginate from "react-paginate";
import { paginationOptions, fetchActionsUtil } from "../../utils/helpers";
import NoTableItem from "../utils/NoTableItem";

export default function GetTemplateModal({
  handleSelectedItem,
  hideItemsNotInStock = false,
  productPlan,
  plant,
}) {
  const { backendUrl } = useAuth();
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 50,
    q: "",
    plant,
  });

  const debouncedqueryParams = useDebounce(queryParams, 500);

  const plantLocal = JSON.parse(window.localStorage.getItem("plantDetails"));

  const { data, isLoading } = useQuery(
    ["GET_BILL_OF_QUANTITY", { debouncedqueryParams }],
    () =>
      productPlan
        ? fetchActionsUtil(
            `${backendUrl}/api/production/all-product-plan?&${queryString.stringify(
              queryParams
            )}`,
            "GET"
          )
        : fetchActionsUtil(
            `${backendUrl}/api/production/bill-of-quantity?&${queryString.stringify(
              {...queryParams, plant:plantLocal?.PLID}
            )}`,
            "GET"
          ),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  // Group data by Plan_Id when productPlan is true
  const getGroupedData = () => {
    if (!productPlan || !data?.billOfQuantities) {
      return data?.billOfQuantities || [];
    }

    const grouped = {};
    data.billOfQuantities.forEach(item => {
      if (!grouped[item.Plan_Id]) {
        grouped[item.Plan_Id] = {
          ...item,
          items: []
        };
      }
      grouped[item.Plan_Id].items.push(item);
    });

    return Object.values(grouped);
  };

  const groupedData = getGroupedData();

  // Create popover content for item names
  const createItemNamesPopover = (items) => (
    <Popover id="item-names-popover">
      <Popover.Body>
        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {items.map((item, index) => (
            <div key={index} className="mb-1">
              <small>{item.Item_Name}</small>
            </div>
          ))}
        </div>
      </Popover.Body>
    </Popover>
  );

  // Format item names display
  const formatItemNames = (items) => {
    if (items.length === 1) {
      return items[0].Item_Name;
    }
    
    const firstItem = items[0].Item_Name;
    const remainingCount = items.length - 1;
    
    return (
      <OverlayTrigger
        placement="top"
        overlay={createItemNamesPopover(items)}
        trigger={['hover', 'focus']}
      >
        <span style={{ cursor: 'pointer' }}>
          {firstItem.length > 20 ? `${firstItem.substring(0, 20)}...` : firstItem}
          {remainingCount > 0 && (
            <span className="badge bg-secondary ms-2">
              +{remainingCount}
            </span>
          )}
        </span>
      </OverlayTrigger>
    );
  };

  // Handle item selection - return all items in the plan for productPlan
  const handleItemClick = (item) => {
    console.log("item clicked: ",item)
    if (handleSelectedItem) {
      if (productPlan) {
        // Return all items in the plan
        handleSelectedItem(item.items || [item]);
      } else {
        handleSelectedItem(item);
      }
    }
  };

  return (
    <div className="items-table-area rounded">
      <div className="search-area m-3">
        <MagnifyIcon />
        <input
          className="form-control search-input"
          name="q"
          value={queryParams.q}
          onChange={(e) =>
            setQueryParams({
              ...queryParams,
              page: 1,
              [e.target.name]: e.target.value,
            })
          }
          placeholder="Search item..."
          autoFocus
          autoComplete="off"
          type={"text"}
        />
      </div>

      <div className="content">
        <Table borderless hover striped className="product-table">
          <thead className="sticky text-nowrap">
            {productPlan ? (
              <tr>
                <th scope="col">Plan Name</th>
                <th scope="col">Item Names</th>
                <th scope="col">Plan Id</th>
                <th scope="col">Total Items</th>
                <th scope="col">Unit Cost</th>
              </tr>
            ) : (
              <tr>
                <th scope="col">Item Code</th>
                <th scope="col">Item Name</th>
                <th scope="col">Unit Cost</th>
                <th scope="col">Unit Price</th>
              </tr>
            )}
          </thead>
          <tbody>
            {groupedData?.length > 0 &&
              groupedData
                ?.filter((el) =>
                  hideItemsNotInStock ? 
                    (productPlan ? 
                      el.items?.some(item => Number(item.Quantity) > 0) : 
                      Number(el.Quantity) > 0
                    ) : el
                )
                ?.map((el, index) => (
                  <>
                    {productPlan ? (
                      <tr
                        className="p-cursor"
                        key={index}
                        onClick={() => handleItemClick(el)}
                      >
                        <td>{el.Plan_Name}</td>
                        <td>{formatItemNames(el.items)}</td>
                        <td title={el?.Quantity}>{el.Plan_Id}</td>
                        <td>
                          <span className="badge bg-primary">
                            {el.items?.length || 1}
                          </span>
                        </td>
                        <td>
                          {currency(el.UnitCost, {
                            precision: 2,
                            symbol: "",
                          }).format()}
                        </td>
                      </tr>
                    ) : (
                      <tr
                        className="p-cursor"
                        key={index}
                        onClick={() => handleItemClick(el)}
                      >
                        <td>{el.Bar_Code}</td>
                        <td title={el?.Quantity}>{el.Item_Name}</td>
                        <td>
                          {currency(el.UnitCost, {
                            precision: 2,
                            symbol: "",
                          }).format()}
                        </td>
                        <td>
                          {currency(el.UnitPrice, {
                            precision: 2,
                            symbol: "",
                          }).format()}
                        </td>
                      </tr>
                    )}
                  </>
                ))}
          </tbody>
        </Table>
        {groupedData?.length < 1 && !isLoading && (
          <div className="d-flex justify-content-center text-center w-100 my-4">
            <NoTableItem queryParams={queryParams} />
          </div>
        )}
      </div>

      <div className="d-flex justify-content-between px-3 my-3 align-items-center pagination">
        <p className="m-0">
          Showing {data?.startIndex + 1} to{" "}
          {data?.endIndex <= data?.count ? data?.endIndex : data?.count} of{" "}
          {data?.count} entries
        </p>

        <ReactPaginate
          {...paginationOptions}
          pageCount={Math.ceil(data?.count / queryParams.limit)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={0}
          onPageChange={({ selected }) => {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            setQueryParams({
              ...queryParams,
              page: selected + 1,
            });
          }}
          forcePage={queryParams.page - 1}
        />
      </div>
    </div>
  );
}